import { render, staticRenderFns } from "./changeRobot.vue.js?vue&type=template&id=55fbc84c&scoped=true!=!../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./changeRobot.vue?vue&type=template&id=55fbc84c&scoped=true"
import script from "./changeRobot.vue.js?vue&type=script&lang=js!=!../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./changeRobot.vue?vue&type=script&lang=js"
export * from "./changeRobot.vue.js?vue&type=script&lang=js!=!../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./changeRobot.vue?vue&type=script&lang=js"
import style0 from "./changeRobot.vue.scss?vue&type=style&index=0&id=55fbc84c&lang=scss&scoped=true!=!../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./changeRobot.vue?vue&type=style&index=0&id=55fbc84c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55fbc84c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/web-hok_Mssh/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55fbc84c')) {
      api.createRecord('55fbc84c', component.options)
    } else {
      api.reload('55fbc84c', component.options)
    }
    module.hot.accept("./changeRobot.vue.js?vue&type=template&id=55fbc84c&scoped=true!=!../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./changeRobot.vue?vue&type=template&id=55fbc84c&scoped=true", function () {
      api.rerender('55fbc84c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/live/Dialog/changeRobot.vue"
export default component.exports